import { Contract } from "web3-eth-contract";
import supe_erc20_abi from "./json/SUPEERC20.json";

export let address = {
    eeg: {
        erc20: "0x663C51ff62632b72aa794b14e4aD452bf1847a57",
    },
};

const provider = "https://bsc-dataseed1.defibit.io";
export const initContractsPrice = () => {
    const contracts = createContract(supe_erc20_abi.abi, address.eeg.erc20);
    return {
        address: address,
        eeg: {
            erc20: contracts,
        },
    };
};
function createContract(abi, contractAddress) {
    const contract = new Contract(abi, contractAddress);
    contract.setProvider(provider);
    return contract;
}
